// NewArrivals.jsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SingleProduct from "../../../../components/general/singleProduct/SingleProduct";
import MyContext from "../../../../contexts/AppContext";
import "../../../../assets/css/customer/subscreens/home/NewArrivals.css";
import { Button } from "react-bootstrap";
import { MdArrowForward } from "react-icons/md";

const NewArrivals = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(MyContext);
  const [products, setProducts] = useState([]);

  const viewNewArrivals = () => {
    axios
      .get(`${baseUrl}/customer/product/viewAllProducts`)
      .then((response) => {
        const allProducts = response.data.products;
        const latest = [...allProducts].reverse().slice(0, 8);
        setProducts(latest);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewNewArrivals();
  }, []);

  const handleViewAll = () => {
    navigate("/categories");
  };

  return (
    <section className="newarrivals-section">
      <div className="container">
        {/* Section Header */}
        <div className="newarrivals-section-header">
          <h2 className="NewArrivals-section-title">NEW ARRIVALS</h2>
          <p className="section-subtitle">
            Discover Our Most Loved Handmade Treasures Crafted With Passion
          </p>
        </div>

        {/* Product Grid */}
        <div className="products-grid">
          {products.map((product) => (
            <SingleProduct key={product.id} product={product} />
          ))}
        </div>

        {/* View All Button */}
        <div className="view-all-section">
          <Button
            className="btn-view-all"
            onClick={() => navigate("/categories")}
          >
            VIEW ALL PRODUCTS
            <MdArrowForward size={22} className="ms-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;
